import clsx from "clsx";
import { FC } from "react";

import Phone from "@/assets/friendsWithBenefits/productTeaserPhone.svg?react";

export type ProductTeaserAccent = "orange" | "rose";

const accentClassName: Record<ProductTeaserAccent, string> = {
  orange: "bg-surface-accent-orange",
  rose: "bg-surface-accent-rose",
};

interface Props {
  /** Product family, set above the product name, e.g. "Flat Mobile". */
  family: string;
  /** Product name rendered as the display line, e.g. "Three". */
  name: string;
  accent?: ProductTeaserAccent;
}

/**
 * Product card at the top of a Friends with Benefits slide: the product name on
 * a coloured field with the phone illustration bleeding out of the card.
 */
export const ProductTeaser: FC<Props> = ({
  family,
  name,
  accent = "orange",
}) => (
  <div
    className={clsx(
      "relative w-full overflow-hidden rounded-lg",
      accentClassName[accent],
    )}
  >
    {/* 2/5 of the card: narrow enough that "Flat Mobile" wraps onto two lines. */}
    <div className="flex w-2/5 flex-col gap-2 px-8 py-4 text-foreground-primary">
      <p className="text-headline-md font-semibold leading-sm">{family}</p>
      <p className="text-headline-2xl font-semibold leading-none">{name}</p>
    </div>

    {/* No size classes: the illustration renders at its exported size. */}
    <Phone className="pointer-events-none absolute right-8 top-4" />
  </div>
);
